import { motion } from "framer-motion";
import logo from "../assets/optimized/PBSLogo.webp"; // replace with your actual path

export default function LogoSplash() {

    

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-brown z-50">
      <motion.img
        src={logo}
        alt="Pure Business Logo"
        initial={{ opacity: 0, scale: 0.5 }}
        animate={{ opacity: 1, scale: 1 }}
        exit={{ opacity: 0 }}
        transition={{ duration: 1 }}
        className="w-100 h-100"
      />
    </div>
  );
}
